export default __webpack_public_path__ + "static/media/blog6.758d4e15.png";